$(function () {
	checkBasketPin();

	$(document).on('click', '.js-basket-remove', (e) => {
		let self = $(e.currentTarget)

		self.closest('.basket-itm').remove();
		basket_stock_calc()
	});

	$(document).on('click', '.basket-itm .js-checkbox', () => {
		if ($('.basket-itm .js-checkbox:checked').length > 0) {
			$('.js-basket-remove-all-btn').removeClass('disabled');
		} else {
			$('.js-basket-remove-all-btn').addClass('disabled');
		}
	});

	$(document).on('click', '.js-basket-remove-all', () => {
		$('.basket-itm .js-checkbox:checked').closest('.basket-itm').each((k, i) => {
			$(i).find('.js-basket-remove').trigger('click')
		})
	});

	$(document).on('change', '.js-basket-select-all', (e) => {
		if ($(e.currentTarget).prop('checked')) {
			$('.basket-itm .js-checkbox').prop('checked', true);
			$('.js-basket-remove-all-btn').removeClass('disabled');
		} else {
			$('.basket-itm .js-checkbox').prop('checked', false);
			$('.js-basket-remove-all-btn').addClass('disabled');
		}
	});

	$('.js-basket-alert-close').on('click', () => {
		$('.basket-alert').addClass("hide")
	})

	$('.basket-alert__text').on('click', () => {
		$('body,html').animate({
			scrollTop: $('.out-of-stock').first().closest('.basket-itm').offset().top - $('.header').outerHeight(true)
		}, 600)
	})
})

const checkBasketPin = () => {
	const pins = $('.header-btns__pin')

	pins.each((k, pin_elem) => {
		let pin = $(pin_elem)
		if (pin.text() !== '0') {
			pin.addClass('show')
		} else {
			pin.removeClass('show')
		}
	})

}

const addFav = (self) => {
	let prodId = parseInt(self.data('prod-id'));
	let action = "addProductInFavourites"

	if (self.hasClass("active")) {
		self.removeClass("active")
		action = "removeProductFromFavourites"
	} else {
		self.addClass("active")
	}

	$.ajax({
		url: "/ajax/favourites.php",
		method: 'post',
		dataType: 'json',
		data: {
			'productId': prodId,
			'action': action
		},
		success: function (obj) {
			console.log(obj)
			if (obj.hasError) {
				alert('Ошибка добавления товара в избранное');
				return false;
			}
			if ($("#header-favorite-count").length) {
				if (obj.count > 0) {
					$("#header-favorite-count").text(obj.count).addClass("show");
				} else {
					$("#header-favorite-count").text(0).removeClass("show")
				}
			} else {
				if (obj.count > 0) $(".favourites-counter-container").append('<span class="header-btns__pin show" id="header-favorite-count">' + obj.count + '</span>')
			}
		},
		error: function (p1, p2, p3) {
			console.log(p1, p2, p3);
		}
	});
}

const toggleFav = (self) => {
	let prodId = parseInt(self.data('prod-id'));
	let action = "ADD_TO_COMPARE_LIST"

	if (self.hasClass("active")) {
		self.removeClass("active")
		action = "DELETE_FROM_COMPARE_LIST"
	} else {
		self.addClass("active")
	}

	$.ajax({
		url: "/ajax/compare.php",
		method: 'post',
		dataType: 'json',
		data: {
			'id': prodId,
			'ajax_action': "Y",
			'action': action
		},
		success: function (obj) {
			if (obj.hasError) {
				alert('Ошибка добавления товара в сравнения');
				return false;
			}
			let countBlock = $("#header-compare-count")
			if (countBlock.length) {
				if (obj.COUNT > 0) {
					countBlock.text(obj.COUNT).addClass("show")
				} else {
					countBlock.text(0).removeClass("show")
				}
			} else {
				if (obj.COUNT > 0) $(".compare-counter-container").append('<span class="header-btns__pin" id="header-compare-count">' + obj.COUNT + '</span>')
			}
		},
		error: function (p1, p2, p3) {
			console.log(p1, p2, p3);
		}
	});
}